export const downloadFile = (fileData: string | Blob, fileName: string) => {
  const url = window.URL.createObjectURL(new Blob([fileData]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};
